import type { GridSpan } from "@/shared/components/Grid";
import { Grid } from "@/shared/components/Grid";
import { Show } from "@/shared/components/Show";
import type { BaseFieldSet, FieldsGridConfig, FieldsGridGroup } from "./types";

interface GridHeaderProps<AssertionsEnum extends string, FieldSet extends BaseFieldSet<AssertionsEnum>> {
    assertions: FieldsGridGroup<AssertionsEnum, FieldSet>["assertions"];
    gridConfig: FieldsGridConfig<AssertionsEnum>;
}

export function GridHeader<AssertionsEnum extends string, FieldSet extends BaseFieldSet<AssertionsEnum>>({
    assertions,
    gridConfig,
}: GridHeaderProps<AssertionsEnum, FieldSet>) {
    const removableColumnGridSpan = gridConfig.Removable ? 1 : 0;
    const assertionsContainerGridSpan = (12 - gridConfig.FieldSetName - removableColumnGridSpan) as GridSpan;

    return (
        <Show.Above breakpoint={700}>
            <Grid.Container>
                <Grid.Field spanDesktop={gridConfig.FieldSetName} />
                <Grid.Field spanDesktop={assertionsContainerGridSpan}>
                    <Grid.Container>
                        {assertions.map((assertionObj) => (
                            <Grid.Field
                                key={assertionObj.assertion}
                                spanDesktop={gridConfig.Assertions.desktop[assertionObj.assertion]}
                            >
                                <label>{assertionObj.label}</label>
                            </Grid.Field>
                        ))}
                    </Grid.Container>
                </Grid.Field>
            </Grid.Container>
        </Show.Above>
    );
}
